import { render, staticRenderFns } from "./PopularPPT.vue?vue&type=template&id=2f77aa7e&scoped=true&"
import script from "./PopularPPT.vue?vue&type=script&lang=js&"
export * from "./PopularPPT.vue?vue&type=script&lang=js&"
import style0 from "./PopularPPT.vue?vue&type=style&index=0&id=2f77aa7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f77aa7e",
  null
  
)

export default component.exports